import React, { useEffect, useState } from "react";
import "./conatct.css";
import { Fade } from "react-awesome-reveal";
import { TextField, Typography } from "@mui/material";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../Notifcation";
import { createContactAction } from "../../redux/actions/ContactusAction";
import { ToastContainer } from "react-toastify";
const Conatct = () => {
  const [name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Message, setMessage] = useState("");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (name === "" || Email === "" || Message === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    await dispatch(
      createContactAction({
        name,
        message: Message,
        email: Email,
      })
    );
    setLoading(false);
    setisPress(false);
    setName("");
    setEmail("");
    setMessage("");
  };
  const res = useSelector((state) => state.ContactusReduser.Createcontactus);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <div id="contsctus">
      {" "}
      <h3 className="text-center tit">تواصل معاَ</h3>
      <section id="contact">
        <div className="contact-box">
          <div className="contact-links">
            <Fade direction="right" triggerOnce="false">
              <h2>VIP</h2>
              <h2>Service Utilities</h2>
              <div className="links">
                <div className="link">
                  <a href={"https://www.facebook.com/profile.php?id=61555376251919&mibextid=ZbWKwL"}>
                    {" "}
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                </div>
                <div className="link">
                  <a href="#d">
                    {" "}
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                </div>
                <div className="link">
                  <a href="#d">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                </div>
                <div className="link">
                  <a href="#d">
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </div>
              </div>
            </Fade>
          </div>

          <div className="contact-form-wrapper">
            <Fade direction="left" triggerOnce="false">
              <form>
                <div className="form-item">
                  <TextField
                    label={
                      <Typography>
                        الأسم
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    variant="outlined"
                  />
                </div>
                <div className="form-item">
                  <TextField
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    label={
                      <Typography>
                        البريد الألكتروني
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    type="text"
                    variant="outlined"
                  />
                </div>
                <div className="form-item">
                  <TextField
                    value={Message}
                    onChange={(e) => setMessage(e.target.value)}
                    label={
                      <Typography>
                        رسالتك
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    type="text"
                    multiline
                    variant="outlined"
                  />
                </div>
                {isPress && loading ? (
                  <button className="buttonadd">
                    <Spinner />
                  </button>
                ) : (
                  <button className="buttonadd" onClick={handlesubmit}>
                    {" "}
                    استكمال الطلب
                  </button>
                )}
              </form>
            </Fade>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default Conatct;
